import {Button} from '@mui/material'
import {ChevronRight, X} from 'lucide-react'
import * as React from 'react'
import {useAppSidebar} from 'src/layouts/main-layout/app-sidebar/app-sidebar-context'
import {CompanieSelectorIcon} from 'src/layouts/main-layout/app-sidebar/icons/companie-selector.icon'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'
import {useCompaniesSelector} from 'src/layouts/main-layout/companies-selector/companies-selector-context'
import {CompaniesSelectorScrollText} from 'src/layouts/main-layout/companies-selector/companies-selector-scroll-text'

export const CompaniesSelectorButton = React.forwardRef<HTMLButtonElement, React.ComponentProps<typeof Button>>((props, ref) => {
  const {selectedCompanies} = useCompaniesSelector()
  const {isCompanieSelectorCollapsed, collapsed} = useAppSidebar()
  const companiesText = selectedCompanies.length ? selectedCompanies.map((c) => c.name).join(', ') : ''

  return (
    <button
      ref={ref}
      {...props}
      style={{
        border: 'none',
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        fontWeight: 'bold',
        color: 'white',
        fontSize: '12px',
        padding: '0px 15px',
        justifyContent: !collapsed && isCompanieSelectorCollapsed ? 'space-between' : 'center',
      }}
      className={cn(collapsed && 'flex h-9 w-10 items-center justify-center')}>
      {collapsed ? (
        <span className={cn('shrink-0', collapsed && 'flex  w-[18px] items-center justify-center')}>
          <CompanieSelectorIcon />
        </span>
      ) : (
        <div className='flex justify-between items-center min-w-full'>
          <div className='flex min-w-0 h-8 items-center gap-3'>
            <CompanieSelectorIcon />

            <div className='relative min-w-0 flex-1 overflow-hidden'>
              <CompaniesSelectorScrollText text={companiesText} className='inline-block max-w-28' />
            </div>
          </div>

          {!collapsed && (isCompanieSelectorCollapsed ? <X className='size-4' /> : <ChevronRight className='size-4' />)}
        </div>
      )}
    </button>
  )
})

CompaniesSelectorButton.displayName = 'CompaniesSelectorButton'
